export default __webpack_public_path__ + "static/media/tickcircle.b10f01f6.svg";